var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Container, TextNode, erzeugeTaktischesZeichen, } from "taktische-zeichen-core";
export default function TaktischesZeichen(_a) {
    var { grundzeichen, fachaufgabe, organisation, einheit, verwaltungsstufe, funktion, symbol, text, name, organisationName } = _a, props = __rest(_a, ["grundzeichen", "fachaufgabe", "organisation", "einheit", "verwaltungsstufe", "funktion", "symbol", "text", "name", "organisationName"]);
    const { svg } = erzeugeTaktischesZeichen({
        grundzeichen,
        fachaufgabe,
        organisation,
        einheit,
        verwaltungsstufe,
        funktion,
        symbol,
        text,
        name,
        organisationName,
    });
    return render(svg, props);
}
function render(element, additionalProps) {
    const children = element instanceof Container
        ? element.children.map((child, key) => render(child, { key }))
        : element instanceof TextNode
            ? element.text
            : null;
    return (_jsx(element.name, Object.assign({}, withCamelCaseKeys(element.attributes), { style: withCamelCaseKeys(element.styles) }, additionalProps, { children: children }), void 0));
}
function withCamelCaseKeys(obj) {
    return Object.entries(obj)
        .map(([key, value]) => [toCamelCase(key), value])
        .reduce((acc, [key, value]) => (Object.assign(Object.assign({}, acc), { [key]: value })), {});
}
function toCamelCase(str) {
    return str.replace(/^([A-Z])|[\s-_](\w)/g, function (_, p1, p2) {
        if (p2)
            return p2.toUpperCase();
        return p1.toLowerCase();
    });
}
